var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 157,
    viewBox: "0 0 139 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M52.423 67.8264C70.4728 67.8264 85.1051 53.2026 85.1051 35.1632C85.1051 17.1238 70.4728 2.5 52.423 2.5C34.3732 2.5 19.741 17.1238 19.741 35.1632C19.741 53.2026 34.3732 67.8264 52.423 67.8264Z",
    fill: "#E0AA74",
    stroke: "#15203D",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M96.9361 102.835C96.0235 99.4921 91.375 85.6076 76.6066 77.3013C65.7411 71.1938 52.423 72.2157 52.423 72.2157C52.423 72.2157 39.1049 71.1938 28.2394 77.3013C13.4669 85.6035 8.81841 99.4921 7.9099 102.835C5.87287 110.311 3.54659 132.518 2.52808 140.69C4.81362 153.239 42.523 154.464 52.423 154.464C62.3229 154.464 100.032 153.239 102.318 140.69C101.299 132.518 98.9731 110.311 96.9361 102.835Z",
    fill: "#E0AA74",
    stroke: "#15203D",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.7787 85.6116V57.7449C93.7787 53.0298 97.6042 49.2106 102.318 49.2106C107.036 49.2106 110.857 53.0339 110.857 57.7449V85.6116H119.396V57.6634C119.396 48.2374 111.749 40.5948 102.318 40.5948C92.8865 40.5948 85.2395 48.2374 85.2395 57.6634V85.6116H93.7787Z",
    fill: "#E0AA74",
    stroke: "#15203D",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.609 73.1278H83.0273C74.8146 73.1278 68.157 79.7816 68.157 87.9895V115.746C68.157 123.954 74.8146 130.608 83.0273 130.608H121.609C129.821 130.608 136.479 123.954 136.479 115.746V87.9895C136.479 79.7816 129.821 73.1278 121.609 73.1278Z",
    fill: "#E0AA74",
    stroke: "#15203D",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.475 96.2306C105.475 94.488 104.061 93.0751 102.318 93.0751C100.574 93.0751 99.1604 94.488 99.1604 96.2306C99.1604 97.615 100.057 98.7917 101.299 99.2152L99.1604 110.657H105.471L103.332 99.2152C104.575 98.7917 105.471 97.6191 105.471 96.2306H105.475Z",
    fill: "#15203D",
    stroke: "#15203D",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminLogo);
export default __webpack_public_path__ + "static/media/Admin_logo.1dfd2fc1a3fc9eb692346de1d937a738.svg";
export { ForwardRef as ReactComponent };